import { message } from '../cls';

import './suggest.less';

export var suggest = message('suggest');
export var arrow = suggest('arrow');
export var bubble = suggest('bubble');
export var wrapper = suggest('wrapper');
export var item = suggest('item')();
export var row = suggest('row')();
export var rows = suggest('rows')();